document.addEventListener('DOMContentLoaded', function() {
  // Wait longer for all payment buttons to load
  setTimeout(function() {
    var bundleWidget = document.getElementById('rbr-container-element-true');
    
    if (bundleWidget) {
      // Create collapsible drawer
      var drawer = document.createElement('details');
      drawer.className = 'bundle-drawer';
      drawer.innerHTML = '<summary class="bundle-drawer__toggle button button-secondary">IN THE BOX</summary><div class="bundle-drawer__content"></div>';
      
      // Move bundle widget into drawer
      drawer.querySelector('.bundle-drawer__content').appendChild(bundleWidget);
      
      // Insert drawer at the very end of buy-buttons-block
      var buyButtonsBlock = document.querySelector('.buy-buttons-block');
      
      if (buyButtonsBlock) {
        buyButtonsBlock.appendChild(drawer);
      }
    }
  }, 3000); // Increased to 3 seconds
});


